import * as React from "react";
import { forwardRef } from "react";
const SvgTabTasks = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 .2v15.535h15.535V5.5L14.24 6.794v7.646H1.295V1.495h12.824L15.413.2Zm15.07 2.124-7.3 7.3L5 6.855l-.93.93 3.23 3.237.465.445.465-.445L16 3.254Z", className: "s1fd6c46bf52769b12e38d3e237c6922a__b" }));
const ForwardRef = forwardRef(SvgTabTasks);
export { ForwardRef as ReactComponent };
